import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonRadioGroup, ModalController, NavParams } from '@ionic/angular';
import { isNotBlank, isNotNullAndUndefined } from 'src/app/utilities/utils';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'src/app/utilities/constant';
import { ConfirmationService } from 'src/app/services/confirmation.service';

interface ManualPlrOption {
  name: string;
  val: string;
  category: string;
}

@Component({
  selector: 'app-plr-screen',
  templateUrl: './plr-screen.component.html',
  styleUrls: ['./plr-screen.component.scss'],
})
export class PlrScreenComponent implements OnInit, AfterViewInit {
  @ViewChild('screenModeGroup') screenModeGroup: IonRadioGroup;
  @ViewChild('graphModeRadio', { read: ElementRef }) graphModeRadio!: ElementRef<HTMLElement>;
  @ViewChild('manualModeRadio', { read: ElementRef }) manualModeRadio!: ElementRef<HTMLElement>;
  @ViewChild('submitButton', { read: ElementRef }) submitButton!: ElementRef<HTMLElement>;
  // Screen toggle
  public screenMode: 'graph' | 'manual' = 'graph'; // 'graph' = PLR from Graph, 'manual' = Enter PLR Value
  public previousScreenMode: 'graph' | 'manual' = 'graph'; // confirmed mode

  // Existing PLR from Graph variables
  plr_value = '';
  category_value = '';
  descriptionValue = ''; // New: concatenated description

  // Translation keys for dropdown options
  private severityKeys = [
    { key: 'S1 = Slight (normally reversible) injury', val: 's1' },
    { key: 'S2 = Serious (normally irreversible) injury, including death', val: 's2' }
  ];

  private frequencyExposureKeys = [
    { key: 'F1 = Seldom to less often and/or the exposure time is short', val: 'f1' },
    { key: 'F2 = Frequent to continous and/or the exposure time is..', val: 'f2' }
  ];

  private possibilityOfAvoidanceKeys = [
    { key: 'P1 = Possible under specific conditions', val: 'p1' },
    { key: 'P2 = Scarcely possible', val: 'p2' }
  ];

  // Translated dropdown lists (initialized in ngOnInit)
  severityList: { name: string; val: string }[] = [];
  frequencyExposureList: { name: string; val: string }[] = [];
  possibilityOfAvoidanceList: { name: string; val: string }[] = [];

  selectedPlrList = { severity: null, freqExpo: null, posOfAvoidance: null };

  // Manual PLR entry variables
  manualPlrOptions: ManualPlrOption[] = [
    { name: 'a', val: 'a', category: 'B' },
    { name: 'b', val: 'b', category: '1' },
    { name: 'c', val: 'c', category: '2' },
    { name: 'd', val: 'd', category: '3' },
    { name: 'e', val: 'e', category: '4' }
  ];

  manualPlrSelection = { value: null, category: null, description: '' };


  @Input() plrObj: any;
  @Input() category: any;
   public manualDescriptionFlag: boolean= false;

  constructor(private confirmationService: ConfirmationService,private translate: TranslateService,public modalController: ModalController, public sharedValue: ShareValuesService, private navParams: NavParams,private toastService: ToastService,) { }

  ngOnInit() {
    // Initialize translated dropdown lists
    this.initializeTranslatedLists();
     this.plrObj = this.navParams.get('plrObj');
    this.onManualDescriptionChange();
      this.setInitialScreenMode();
      this.previousScreenMode = this.screenMode;

   
    if (this.plrObj && !this.plrObj?.isPlrFromGraph && this.plrObj?.sValue) {
       this.manualPlrSelection.description = '';
      this.manualPlrSelection.value = null;
      this.manualPlrSelection.category = '';
      this.selectedPlrList.severity = this.plrObj.sValue;
      this.selectedPlrList.freqExpo = this.plrObj.fValue;
      this.selectedPlrList.posOfAvoidance = this.plrObj.pValue;
      this.category_value = this.category;
      this.calculateCategory();
      this.calculatePlrValue(); 
    }

    if(this.plrObj && this.plrObj?.isPlrFromGraph){
      this.manualPlrSelection.description = this.plrObj?.plrDescription
      this.manualPlrSelection.value = this.plrObj?.sValue
      this.manualPlrSelection.category = this.plrObj?.category
       this.calculateCategory();
      this.calculatePlrValue();
       this.selectedPlrList.severity = null;
      this.selectedPlrList.freqExpo = null;
      this.selectedPlrList.posOfAvoidance = null;
      this.category_value = '';
      this.plr_value = '';
      this.descriptionValue = '';
    }
    this.sharedValue.sValue = '';
    this.sharedValue.fValue = '';
    this.sharedValue.pValue = '';
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.focusActiveRadio();
    }, 0);
  }

  /**
   * Initializes dropdown lists with translated values
   */
  private initializeTranslatedLists(): void {
    this.severityList = this.severityKeys.map(item => ({
      name: this.translate.instant(item.key),
      val: item.val
    }));

    this.frequencyExposureList = this.frequencyExposureKeys.map(item => ({
      name: this.translate.instant(item.key),
      val: item.val
    }));

    this.possibilityOfAvoidanceList = this.possibilityOfAvoidanceKeys.map(item => ({
      name: this.translate.instant(item.key),
      val: item.val
    }));
  }

  /**
   *  screen mode between graph and manual entry
   */
isInitialized = false;
setInitialScreenMode() {
  if (this.isInitialized) return;
  this.screenMode = this.previousScreenMode = this.plrObj?.isPlrFromGraph === true  ? 'manual': 'graph';
  this.isInitialized = true;

}


async onScreenModeChange(event: any) {
  const newMode = event.detail.value;

  // If same mode → ignore
  if (newMode === this.screenMode) return;

  const hasData =
  (this.screenMode === 'manual' && (
    !!this.manualPlrSelection.description?.trim() ||
    !!this.manualPlrSelection.value ||
    !!this.manualPlrSelection.category
  )) ||
  (this.screenMode === 'graph' && (
    !!this.selectedPlrList.severity ||
    !!this.selectedPlrList.freqExpo ||
    !!this.selectedPlrList.posOfAvoidance ||
    !!this.category_value ||
    !!this.plr_value
  ));
  if (hasData) {
    
     const title = this.translate.instant('your_current_data_will_be_lost_do_you_want_to_continue')
      const actionText1 = this.translate.instant('OK');
       const actionText2 = this.translate.instant('Cancel');
    const isConfirmed = await this.confirmationService.presentConfirmationModal(
      title,
      actionText1,
      true,
      actionText2
    );

    if (isConfirmed) {
      this.screenMode = newMode;
      this.previousScreenMode = newMode;
      this.clearDataBasedOnMode();
      setTimeout(() => {
        this.focusActiveRadio();
      }, 0);
    } else {
      // Revert radio UI selection when user cancels the confirmation.
      this.screenMode = this.previousScreenMode;
      if (this.screenModeGroup) {
        this.screenModeGroup.value = this.previousScreenMode;
      }
    }

  } else {
    // No data → switch immediately
    this.screenMode = newMode;
    this.previousScreenMode = newMode;
    this.clearDataBasedOnMode();
    setTimeout(() => {
      this.focusActiveRadio();
    }, 0);
  }
}

clearDataBasedOnMode() {
  if (this.screenMode === 'graph') {
    // Clear manual inputs
    this.manualPlrSelection.description = '';
    this.manualPlrSelection.value = null;
    this.manualPlrSelection.category = '';
  } else if (this.screenMode === 'manual') {
    // Clear graph inputs
    this.selectedPlrList.severity = null;
    this.selectedPlrList.freqExpo = null;
    this.selectedPlrList.posOfAvoidance = null;
    this.category_value = '';
    this.plr_value = '';
    this.descriptionValue = '';
  }
}

  /**
   * Handle manual PLR value selection and auto-fill category
   */
onManualPlrValueChange(value: ManualPlrOption | null) {
  const selected = this.manualPlrOptions.find(opt => opt.val === value.val);

  if (selected) {
    this.manualPlrSelection.value = selected.val;
    this.manualPlrSelection.category = selected.category;
  } else {
    this.manualPlrSelection.value = null;
    this.manualPlrSelection.category = null;
  }
}

  /**
   * Update manual description character counter
   */
 
  readonly MANUAL_DESCRIPTION_MAX_LENGTH = 2501;
readonly defaultManualDescriptionLength = 2500;

currentManualDescriptionLength = 0;
remainingManualDescriptionChars = 2500;
isManualDescriptionOverMaxLength = false;

onManualDescriptionChange(event?) {
  const value = event
    ? event.target.value
    : this.manualPlrSelection.description?.length
      ? this.manualPlrSelection.description
      : '';

  this.currentManualDescriptionLength = value.length;
  this.remainingManualDescriptionChars = this.defaultManualDescriptionLength - this.currentManualDescriptionLength;
  this.isManualDescriptionOverMaxLength = this.currentManualDescriptionLength >= this.MANUAL_DESCRIPTION_MAX_LENGTH;

  if (this.manualDescriptionFlag && value?.trim()) {
    this.manualDescriptionFlag = false;
  }
}

  /**
   * Update description for graph-mode (concatenate severity, frequency, avoidance)
   */
 updateGraphDescription() {
  const { severity, freqExpo, posOfAvoidance } = this.selectedPlrList;

  const severityLabel = this.severityList.find(s => s.val === severity)?.name || '';
  const freqLabel = this.frequencyExposureList.find(f => f.val === freqExpo)?.name || '';
  const avoidLabel = this.possibilityOfAvoidanceList.find(a => a.val === posOfAvoidance)?.name || '';

  // Get translated headers
  const severityHeader = this.translate.instant('Severity');
  const frequencyHeader = this.translate.instant('Frequency of Exposure');
  const avoidanceHeader = this.translate.instant('Possibility of Avoidance');

  if (severityLabel && freqLabel && avoidLabel) {
    this.descriptionValue = `
      <div class="desc-block">
        <h6 class="desc-title">${severityHeader}</h6>
        <div class="desc-value">${severityLabel}</div>
      </div>

      <div class="desc-block">
        <h6 class="desc-title">${frequencyHeader}</h6>
        <div class="desc-value">${freqLabel}</div>
      </div>

      <div class="desc-block">
        <h6 class="desc-title">${avoidanceHeader}</h6>
        <div class="desc-value">${avoidLabel}</div>
      </div>
    `;
  } else {
    this.descriptionValue = '';
  }
}

  close() {
    this.modalController.dismiss({});
  }

  handleSubmitTab(event: KeyboardEvent) {
    if (event.shiftKey) {
      return;
    }

    event.preventDefault();
    this.focusActiveRadio();
  }

  handleRadioShiftTab(event: KeyboardEvent) {
    if (!event.shiftKey) {
      return;
    }

    event.preventDefault();
    this.submitButton?.nativeElement?.focus();
  }

  private focusActiveRadio() {
    const activeRadio = this.screenMode === 'manual'
      ? this.manualModeRadio?.nativeElement
      : this.graphModeRadio?.nativeElement;

    activeRadio?.focus();
  }

  /**
   * Cancel button - same as close
   */
  cancel() {
    this.close();
  }

  calculatePlrValue() {
    const { severity, freqExpo, posOfAvoidance } = this.selectedPlrList;
    if (isNotBlank(severity) && isNotNullAndUndefined(severity) && isNotBlank(freqExpo) && isNotNullAndUndefined(freqExpo) && isNotBlank(posOfAvoidance) && isNotNullAndUndefined(posOfAvoidance)) {
      if (severity == 's1' && freqExpo == 'f1' && posOfAvoidance == 'p1') {this.plr_value = 'a';}
      else if (severity == 's1' && freqExpo == 'f1' && posOfAvoidance == 'p2') {this.plr_value = 'b';}
      else if (severity == 's1' && freqExpo == 'f2' && posOfAvoidance == 'p1') {this.plr_value = 'b';}
      else if (severity == 's1' && freqExpo == 'f2' && posOfAvoidance == 'p2') {this.plr_value = 'c';}
      else if (severity == 's2' && freqExpo == 'f1' && posOfAvoidance == 'p1') {this.plr_value = 'c';}
      else if (severity == 's2' && freqExpo == 'f1' && posOfAvoidance == 'p2') {this.plr_value = 'd';}
      else if (severity == 's2' && freqExpo == 'f2' && posOfAvoidance == 'p1') {this.plr_value = 'd';}
      else if (severity == 's2' && freqExpo == 'f2' && posOfAvoidance == 'p2') {this.plr_value = 'e';}
    } else if (this.plr_value) {this.plr_value = '';}
    this.sharedValue.sValue = severity;
    this.sharedValue.fValue = freqExpo;
    this.sharedValue.pValue = posOfAvoidance;
    this.calculateCategory();
    this.updateGraphDescription(); // Update description when values change
  }

  calculateCategory() {
    if (!this.selectedPlrList.severity || !this.selectedPlrList.freqExpo || !this.selectedPlrList.posOfAvoidance)  return
    if (this.plr_value) {
      if (this.plr_value == 'a') {this.category_value = 'B';}
      else if (this.plr_value == 'b') {this.category_value = '1';}
      else if (this.plr_value == 'c') {this.category_value = '2';}
      else if (this.plr_value == 'd') {this.category_value = '3';}
      else if (this.plr_value == 'e') {this.category_value = '4';}
    }
  }


  submitPlrValue() {
  let missingFields: { field: string; action: 'select' | 'enter' }[] = [];

  if (this.screenMode === 'graph') {
    // Graph submission
    if (this.plr_value) {
      this.modalController.dismiss({
        plr_value: this.plr_value,
        category_value: this.category_value,
        sValue: this.selectedPlrList.severity,
        fValue: this.selectedPlrList.freqExpo,
        pValue: this.selectedPlrList.posOfAvoidance,
        plrDescription: this.descriptionValue,
        isPlrFromGraph: false
      });
    } else {
      if (!this.selectedPlrList?.severity) {
        missingFields.push({ field: 'Severity', action: 'select' });
      }

      if (!this.selectedPlrList?.freqExpo) {
        missingFields.push({ field: 'Frequency of Exposure', action: 'select' });
      }

      if (!this.selectedPlrList?.posOfAvoidance) {
        missingFields.push({ field: 'Possibility of Avoidance', action: 'select' });
      }
    }

  } else {
    // Manual submission
    const manualDescription = this.manualPlrSelection?.description || '';
    const trimmedManualDescription = manualDescription.trim();
    const isOnlySpaces = manualDescription.length > 0 && !trimmedManualDescription;

    if (isOnlySpaces) {
      this.manualDescriptionFlag = true;
      this.toastService.presentToast(
       this.translate.instant('only_spaces_are_not_allowed'),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      return;
    }

    if (
      this.manualPlrSelection?.value &&
      this.manualPlrSelection?.category &&
      trimmedManualDescription
    ) {
      this.modalController.dismiss({
        sValue: this.manualPlrSelection.value,
        category: this.manualPlrSelection.category,
        plrDescription: manualDescription,
        isPlrFromGraph: true
      });
    } else {
      if (!this.manualPlrSelection?.value) {
        missingFields.push({ field: 'Value', action: 'select' });
      }


      if (!trimmedManualDescription) {
        missingFields.push({ field: 'Description', action: 'enter' });
        this.manualDescriptionFlag = true;
      }
    }
  }

  // Show validation message
  if (missingFields.length > 0) {
    const message = missingFields
      .map(item => {
        if (item.action === 'enter' && item.field === 'Description') {
          return this.translate.instant('Enter Description');
        }

        const actionLabel = this.translate.instant('Select');
        const fieldLabel = this.translate.instant(item.field);
        return `${actionLabel} ${fieldLabel}`;
      })
      .join(', ');

    this.toastService.presentToast(
      message ,
      4000,
      AppConstants.WARNING_SNACKBAR,
      'top'
    );
    return;
  }
}
}
